import script from "./EditCoverageDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCoverageDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditCoverageDialog.vue?vue&type=style&index=0&id=541317ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-541317ae"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField});
